/**
 * 快照号徽标（plan-page-design ref 02、ref 04 O-8；PR3 新写，PR6 改为页内跳转）：中性徽标 + 等宽字，点开配置版本页的该快照。
 * PR6：改用路由 Link（`/plan-lab?snapshot=…#config-versions`），不整页刷新——提示词页的未保存草稿不会因此丢掉。
 * 在配置版本页自己的列表里传 `onOpen`，就地开对比抽屉。
 */
import { Link } from "@tanstack/react-router";

import { Badge } from "@/components/ui/badge";

function shortId(id: string) {
	return id.length > 14 ? `${id.slice(0, 14)}…` : id;
}

export function SnapshotTag({
	id,
	onOpen,
}: {
	id: string | null | undefined;
	/** 给了就不跳页，改为调用它（配置版本页列表里用） */
	onOpen?: (id: string) => void;
}) {
	if (!id) return <span className="text-text-muted">—</span>;
	const badge = (
		<Badge tone="neutral" className="font-mono hover:bg-surface-muted">
			{shortId(id)}
		</Badge>
	);
	return (
		<Link
			to="/plan-lab"
			search={{ snapshot: id }}
			hash="config-versions"
			title={`配置快照 ${id}（点开看这份配置）`}
			onClick={(e) => {
				e.stopPropagation();
				if (onOpen) {
					e.preventDefault();
					onOpen(id);
				}
			}}
			className="inline-flex"
			data-testid="plan-snapshot-tag"
		>
			{badge}
		</Link>
	);
}

/**
 * 题库快照号（O-8：与配置快照号同形态、不同前缀）。题库快照没有自己的页（评测配置组 P3），只显示、不可点。
 */
export function BankTag({ id }: { id: string | null | undefined }) {
	if (!id) return <span className="text-text-muted">—</span>;
	return (
		<span
			className="inline-flex"
			title={`题库快照 ${id}（题库快照在评测配置上线后可查看）`}
			data-testid="plan-bank-tag"
		>
			<Badge tone="neutral" className="font-mono">
				{shortId(id)}
			</Badge>
		</span>
	);
}
